document.addEventListener('sealsubs:price_update', function(e) {
  const { price, compareAtPrice, element, pricePerDelivery } = e.detail;
  const activeOption = element.querySelector('.sls-option-container.seal-table.sls-active');
    if (activeOption) {
        const totalPriceElement = activeOption.querySelector('.sls-total-price');
        console.log(totalPriceElement)
        if (totalPriceElement) {
            const btnPriceEl = document.querySelector('.section-main-product .button-add-to-cart .product-atc-btn-price');
            const stickyBtnPriceEl = document.querySelector('sticky-add-to-cart quick-add-button .button .product-atc-btn-price');
            if (btnPriceEl) {btnPriceEl.innerHTML = totalPriceElement.innerHTML;}
            if (stickyBtnPriceEl) {stickyBtnPriceEl.innerHTML = totalPriceElement.innerHTML;}
        }
    }
});